import dayjs from "dayjs";
import { currencyOptions as coreCurrencyOptions } from "../core/currency";

export const boxLabels = {
  "watch-box-papers": "Watch with Box & Papers",
  "watch-only": "Watch only",
  "watch-papers": "Watch with Papers",
  "watch-box": "Watch with Box",
};

export const boxOptions = [
  { id: "watch-box-papers", name: "Watch with Box & Papers" },
  { id: "watch-only", name: "Watch only" },
  { id: "watch-papers", name: "Watch with Papers" },
  { id: "watch-box", name: "Watch with Box" },
];

// Derived from core/currency but with this site's legacy shape: UPPERCASE
// ids and the historical EURO / CRYPTO-USDT wording. NOTE: snapshot taken at
// module load — equals the legacy five until multi-currency is seeded (which
// happens after load); new consumers should call core/currency's
// currencyOptions() directly for a live list.
const LEGACY_CURRENCY_NAMES = { EUR: "EURO", USDT: "CRYPTO-USDT" };
export const currencyOptions = coreCurrencyOptions().map(({ id }) => {
  const upperId = id.toUpperCase();
  return { id: upperId, name: LEGACY_CURRENCY_NAMES[upperId] ?? upperId };
});

export const paymentTypeOptions = [
  { id: "wire", name: "Bank Transfer" },
  { id: "card", name: "Card" },
  { id: "cash", name: "Cash" },
];

export const monthLabels = {
  0: "",
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

export const monthOptions = [
  { id: "0", name: "Month" },
  { id: "1", name: "January" },
  { id: "2", name: "February" },
  { id: "3", name: "March" },
  { id: "4", name: "April" },
  { id: "5", name: "May" },
  { id: "6", name: "June" },
  { id: "7", name: "July" },
  { id: "8", name: "August" },
  { id: "9", name: "September" },
  { id: "10", name: "October" },
  { id: "11", name: "November" },
  { id: "12", name: "December" },
];

export const genderOptions = [
  { id: null, name: "Gender" },
  { id: "men", name: "Men’s watch/Unisex" },
  { id: "women", name: "Women’s watch" },
];

const currentYear = dayjs().year();
export const yearOptions = [...Array(100)].map((_, diff) => ({
  id: currentYear - diff,
  name: currentYear - diff,
}));

export const sourceOptions = [
  { id: "trade", name: "Trade" },
  { id: "instagram", name: "Instagram" },
  { id: "chrono24", name: "Chrono24" },
  { id: "watch_finder", name: "Watch Finder" },
  { id: "watch_collecting", name: "Watch Collecting" },
  { id: "ebay", name: "EBay" },
  { id: "antiquorum", name: "Antiquorum" },
  { id: "christies", name: "Christie's" },
  { id: "phillips", name: "Phillips" },
  { id: "bonhams", name: "Bonhams" },
  { id: "ineichen", name: "Ineichen" },
  { id: "monaco_legend", name: "Monaco Legend" },
  { id: "bukowskis", name: "Bukowskis" },
  { id: "sothebys", name: "Sotheby's" },
  { id: "eppli", name: "Eppli" },
];

export const sellerTypeOptions = [
  { id: "professional_dealer", name: "Professional dealer" },
  { id: "private_seller", name: "Private Seller" },
];

export const locationOptions = [
  { id: "uk", name: "UK" },
  { id: "europe", name: "Europe" },
  { id: "usa", name: "USA" },
  { id: "middle-east", name: "Middle East" },
  { id: "asia", name: "Asia" },
  { id: "north-america", name: "North America" },
  { id: "south-america", name: "South America" },
  { id: "africa", name: "Africa" },
  { id: "australia", name: "Australia" },
];

export const conditionOptions = [
  { id: "new", name: "New" },
  { id: "excellent", name: "Excellent" },
  { id: "very-good", name: "Very Good" },
  { id: "good", name: "Good" },
  { id: "fair", name: "Fair" },
];

export const conditionLabels = {
  new: "New",
  excellent: "Excellent",
  "very-good": "Very Good",
  good: "Good",
  fair: "Fair",
};

export const priceSortByOptions = [
  { id: "sort-by-date", name: "SORT BY: Price date" },
  { id: "sort-by-price", name: "SORT BY: Price Low to High" },
  { id: "sort-by-underpriced", name: "FILTER: Deal" },
];
